var _a, _b;
import { initReactI18next } from "react-i18next";
import { createInstance } from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import getLanguageFromStorage from "syf-js-utilities/helpers/getLanguageFromStorage";
import en from "./en";
import es from "./es";
export var defaultNS = "statements-mfe";
export var resources = {
    en: (_a = {},
        _a[defaultNS] = en,
        _a),
    es: (_b = {},
        _b[defaultNS] = es,
        _b),
};
var statementsI18n = createInstance({
    lng: getLanguageFromStorage(),
    fallbackLng: "en",
    defaultNS: defaultNS,
    debug: false,
    interpolation: {
        escapeValue: false,
    },
    resources: resources,
});
statementsI18n.use(LanguageDetector).use(initReactI18next).init();
export default statementsI18n;
